module.exports = __webpack_public_path__ + "static/pokoj-nr6-photo04-13acbc1b09390ab13d0ef4ba38cc114e.jpg";